module.exports = __webpack_public_path__ + "img/aion.faa5cab4.svg";